<template>
  <div style="padding: 20px">
    <el-table :data="paramList" class="mt10">
      <el-table-column
        label="参数"
        width="180"
        prop="typeName"
      ></el-table-column>
      <el-table-column
        label="默认上限值"
        width="180"
        prop="upperLimit"
      ></el-table-column>
      <el-table-column
        label="默认下限值"
        width="180"
        prop="lowerLimit"
      ></el-table-column>
      <el-table-column
        label="标准差默认上限值"
        width="180"
        prop="stdUpperLimit"
      ></el-table-column>
      <el-table-column
        label="标准差默认下限值"
        width="180"
        prop="stdLowerLimit"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="editUser(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      title="修改参数"
      width="500px"
      @close="visible = false"
      class="transtant-input"
    >
      <el-form
        label-width="150px"
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
      >
        <el-form-item label="默认上限值" prop="upperLimit">
          <el-input
            v-model.number="ruleForm.upperLimit"
            placeholder="请输入默认上限值"
            style="width: 300px"
            :maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="默认下限值" prop="lowerLimit">
          <el-input
            v-model.number="ruleForm.lowerLimit"
            placeholder="请输入默认下限值"
            style="width: 300px"
            :maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="标准差默认上限值" prop="stdUpperLimit">
          <el-input
            v-model.number="ruleForm.stdUpperLimit"
            placeholder="请输入标准差默认上限值"
            style="width: 300px"
            :maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="标准差默认下限值" prop="stdLowerLimit">
          <el-input
            v-model.number="ruleForm.stdLowerLimit"
            placeholder="请输入标准差默认下限值"
            style="width: 300px"
            :maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="saveParam">保存</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      paramList: [],
      visible: false,
      ruleForm: {
        upperLimit: '',
        lowerLimit: '',
        stdUpperLimit: '',
        stdLowerLimit: ''
      },
      rules: {
        upperLimit: [
          { required: true, message: '请输入默认上限值', trigger: 'blur' },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ],
        lowerLimit: [
          { required: true, message: '请输入默认下限值', trigger: 'blur' },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ],
        stdUpperLimit: [
          {
            required: true,
            message: '请输入标准差默认上限值',
            trigger: 'blur'
          },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ],
        stdLowerLimit: [
          {
            required: true,
            message: '请输入标准差默认下限值',
            trigger: 'blur'
          },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ]
      }
    };
  },
  async mounted() {
    await this.getParamList();
  },
  methods: {
    async getParamList() {
      const { data } = await this.$fetch('/manage/windfarm/getParamList', {
        module: 'manage'
      });
      this.paramList = data.defaultParam;
    },
    async editUser(row) {
      this.visible = true;
      this.typeId = row && row.typeId;
      this.typeKey = row && row.typeKey;
      this.typeName = row && row.typeName;
      this.ruleForm.upperLimit = row && row.upperLimit;
      this.ruleForm.lowerLimit = row && row.lowerLimit;
      this.ruleForm.stdUpperLimit = row && row.stdUpperLimit;
      this.ruleForm.stdLowerLimit = row && row.stdLowerLimit;
      this.state = row && row.state;
    },
    async saveParam() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          await this.$fetch({
            url: '/manage/windfarm/saveParamList',
            module: 'manage',
            method: 'post',
            data: {
              channelType: {
                typeId: this.typeId,
                typeKey: this.typeKey,
                typeName: this.typeName,
                upperLimit: this.ruleForm.upperLimit,
                lowerLimit: this.ruleForm.lowerLimit,
                stdUpperLimit: this.ruleForm.stdUpperLimit,
                stdLowerLimit: this.ruleForm.stdLowerLimit,
                state: this.state
              }
            },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          this.visible = false;
          this.getParamList();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}
</style>
